import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check } from 'lucide-react';
const tomosData = [{
  id: 1,
  icon: '📗',
  title: 'TOMO 1 — Planificación Resuelto',
  subtitle: 'El instructor que planifica, gana',
  items: ['Qué es periodización y por qué cambia todo', 'Diferencia entre sesión, microciclo y macrociclo', 'Los 3 errores más comunes al planificar', 'Modelo de planificación anual completo', 'Las 4 fases de toda sesión de fútbol', '10 modelos de sesión listos para usar', 'Planificación por objetivos: técnica, táctica y físico', 'Planillas de registro, asistencia y evolución', 'Cómo presentar tu planificación a un club', 'Modelo de informe de temporada']
}, {
  id: 2,
  icon: '📘',
  title: 'TOMO 2 — Técnica Individual Resuelto',
  subtitle: 'Construí jugadores completos desde la base',
  items: ['Las 8 habilidades técnicas esenciales del fútbol', 'Cómo enseñar técnica sin aburrir al grupo', 'Errores técnicos frecuentes y sus correcciones exactas', 'Progresión de aprendizaje por nivel', '15 ejercicios de dominio y control progresivo', 'Control orientado en situaciones reales de partido', '12 ejercicios de conducción con obstáculos', 'Los 6 regates más efectivos explicados paso a paso', 'Mecánica del pase corto, largo y filtrado', '12 ejercicios de finalización por zona']
}, {
  id: 3,
  icon: '📙',
  title: 'TOMO 3 — Táctica Colectiva Resuelto',
  subtitle: 'Que tu equipo piense como uno solo',
  items: ['Principios ofensivos y defensivos explicados simple', 'Cómo enseñar táctica sin pizarrón complicado', 'Fases del juego: ataque, defensa y transiciones', '4-3-3, 4-4-2 y 3-5-2 explicados para instructores', 'Cómo elegir el sistema según tus jugadores', '8 corners ofensivos con diagramas listos', '6 corners defensivos diagramados', 'Tiros libres directos e indirectos', 'Cómo entrenar transición defensa-ataque', 'Pressing alto, medio y bajo con ejercicios reales']
}, {
  id: 4,
  icon: '📕',
  title: 'TOMO 4 — Preparación Física Resuelto',
  subtitle: "Jugadores que llegan al 90' enteros",
  items: ['Las 5 capacidades físicas del futbolista', 'Cómo integrar lo físico dentro de la técnica', 'Test de condición física para tu plantel', '12 ejercicios de velocidad de reacción', 'Sprints cortos y aceleraciones con variantes', 'Circuitos de explosividad sin gimnasio', 'Resistencia específica para futbolistas', '10 circuitos de resistencia con pelota', 'Las lesiones más comunes y cómo prevenirlas', 'Protocolo de recuperación entre partidos']
}, {
  id: 5,
  icon: '📓',
  title: 'TOMO 5 — Arqueros Resuelto',
  subtitle: 'El puesto más olvidado, ahora resuelto',
  items: ['Posición base y desplazamientos correctos', 'Cómo enseñar a un arquero desde cero', 'Los 5 errores más comunes en porteros', 'Técnica de caída y blocaje paso a paso', 'Achique y salida del arco en situaciones reales', '10 ejercicios de reflejos y reacción', 'El arquero moderno como primer jugador', '8 ejercicios de juego con los pies', 'Sesiones individuales de 20 minutos', 'Planificación anual específica del portero']
}, {
  id: 6,
  icon: '📔',
  title: 'TOMO 6 — Psicología y Liderazgo Resuelto',
  subtitle: 'El instructor que forma personas, no solo jugadores',
  items: ['Cómo funciona la mente del futbolista', 'Manejo de la presión antes del partido', 'Motivación intrínseca vs extrínseca aplicada al fútbol', 'Cómo manejar conflictos dentro del plantel', 'Roles dentro del equipo y cómo gestionarlos', 'Liderazgo positivo para instructores', 'Comunicación efectiva con jugadores y padres', 'Cómo reaccionar ante la derrota sin perder el grupo', 'Rutinas mentales pre y post partido', 'Plan de desarrollo profesional del instructor']
}];
export function TomosSlider() {
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const toggleExpand = (id: number) => {
    setExpandedId(expandedId === id ? null : id);
  };
  return <Section className="bg-gray-50" data-id="element-353">
      <div className="text-center mb-6 md:mb-12" data-id="element-354">
        <h2 className="text-3xl md:text-5xl font-black text-dark mb-2 md:mb-4" data-id="element-355">
          Los 6 Tomos
        </h2>
        <p className="text-base md:text-xl text-gray-600 font-medium" data-id="element-356">
          Para instructores de fútbol de todos los niveles y enfoques
        </p>
        <p className="text-xs text-primary font-bold mt-2" data-id="element-357">
          Tocá cada tomo para ver el contenido
        </p>
      </div>

      {/* Vertical stacked rows */}
      <div className="space-y-3 md:space-y-4" data-id="element-358">
        {tomosData.map(tomo => {
        const isExpanded = expandedId === tomo.id;
        return <motion.div key={tomo.id} layout onClick={() => toggleExpand(tomo.id)} className={`cursor-pointer bg-white rounded-xl shadow-md border-2 transition-colors duration-300 relative overflow-hidden ${isExpanded ? 'border-primary shadow-lg' : 'border-gray-200 hover:border-primary/40'}`} data-id="element-359">
              {/* Subtle number background */}
              <div className="absolute -right-4 -top-6 text-9xl font-black text-gray-50 opacity-50 pointer-events-none select-none z-0" data-id="element-360">
                {tomo.id}
              </div>

              <div className="p-4 md:p-6 relative z-10" data-id="element-361">
                <div className="flex items-center justify-between" data-id="element-362">
                  <div className="flex items-center space-x-3 min-w-0" data-id="element-363">
                    <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-gray-50 rounded-full border border-gray-100 flex-shrink-0" data-id="element-364">
                      <span className="text-xl md:text-2xl" data-id="element-365">{tomo.icon}</span>
                    </div>
                    <h3 className="text-sm md:text-xl font-black text-dark leading-tight truncate" data-id="element-366">
                      {tomo.title}
                    </h3>
                  </div>
                  <motion.div animate={{
                rotate: isExpanded ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0 ml-2" data-id="element-367">
                    <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-368" />
                  </motion.div>
                </div>

                <AnimatePresence data-id="element-369">
                  {isExpanded && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-370">
                      <div className="pt-3 mt-3 border-t border-gray-100" data-id="element-371">
                        <p className="font-bold text-primary mb-3 text-sm md:text-base" data-id="element-372">
                          {tomo.subtitle}
                        </p>
                        <ul className="space-y-2" data-id="element-373">
                          {tomo.items.map((item, idx) => <li key={idx} className="flex items-start text-xs md:text-sm text-gray-700 font-medium" data-id="element-374">
                              <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary mr-2 flex-shrink-0 mt-0.5" data-id="element-375" />
                              <span data-id="element-376">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>;
      })}
      </div>

      {/* Cada tomo incluye */}
      <div className="mt-8 md:mt-16 max-w-4xl mx-auto bg-white p-4 md:p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-377">
        <h3 className="text-lg md:text-2xl font-black text-center mb-4 md:mb-8 text-dark" data-id="element-378">
          Cada tomo incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4" data-id="element-379">
          {['Planificación lista para usar desde el primer día', 'Sesiones con objetivo, desarrollo y cierre', 'Cueings y consignas listos para decir en la cancha', 'Variaciones Nivel 1, Nivel 2 y Nivel 3 por ejercicio', 'Checklist pre y durante el entrenamiento', 'Planillas de seguimiento de jugadores', 'Adaptaciones para grupos heterogéneos', '100% adaptado al fútbol amateur y formativo argentino'].map((item, i) => <div key={i} className="flex items-center space-x-2" data-id="element-380">
              <div className="bg-green-100 p-0.5 md:p-1 rounded-full flex-shrink-0" data-id="element-381">
                <Check className="w-3 h-3 md:w-4 md:h-4 text-primary" data-id="element-382" />
              </div>
              <span className="font-semibold text-gray-700 text-xs md:text-base" data-id="element-383">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </Section>;
}